import icon_th from 'src/assets/thailand.png';
import icon_en from 'src/assets/en.png';

export interface ILang {
	[key: string]: {
		text: string;
		lng: 'en' | 'th';
		icon: string;
	};
}

const LANG: ILang = {
	EN: {
		text: 'English',
		lng: 'en',
		icon: icon_en,
	},
	TH: {
		text: 'Thailand',
		lng: 'th',
		icon: icon_th,
	},
};

export const getLangWithKey = (key: ILang['key']['lng']): ILang['key'] => {
	// @ts-ignore
	return LANG[Object.keys(LANG).filter((f) => key.includes(LANG[f].lng))];
};

export default LANG;
